export enum HeaderMainNavigationContent {
  OTHER = 'other',
  THERAPISTS = 'therapists',
  CLINIC = 'clinic',
  BUSINESS_HOW = 'business-how',
  BUSINESS_SOLUTION = 'business-solution',
}

export enum HeaderSubNavigationType {
  DEFAULT = 'default',
  TAGS = 'tags',
}
